import {withState, t} from 'shared/core';
import CheckInSummaryList from '../CheckInSummaryList';
import CheckInSummaryItem from '../CheckInSummaryItem';
import CheckInDetails from '../CheckInDetails';
import RevieweeHeader from '../RevieweeHeader';
import RevieweeDetailsEmptyState from './RevieweeDetailsEmptyState';
import {observer} from 'mobx-react';
import _ from 'lodash';
import {Spinner, Display} from 'shared/components';
import ManagerCheckInState from './state/ManagerCheckInState';

const RevieweeDetailsContainer = observer(({uiState}) => {
  return (
    <div>
      <Display backPath='/reviewees' backTitle={t('performance.Check-Ins I Lead')}/>
      <RevieweeHeader reviewee={uiState.checkInState.selectedReviewee}/>
      {!_.isEmpty(uiState.checkInState.allCheckins) && <div className='Container'>
        <div className='flex flex-wrap content-stretch bg-white rounded box-shadow-3'>
          <CheckInSummaryList>
            {uiState.checkInState.allCheckins.map(checkin => <CheckInSummaryItem key={checkin.id} checkin={checkin} onClick={uiState.onCheckInSelected}/>)}
          </CheckInSummaryList>
          {
            uiState.checkInState.selectedCheckin && !uiState.checkInState.isLoading &&
              <CheckInDetails
                checkin={uiState.checkInState.selectedCheckin}
                reviewee={uiState.checkInState.selectedReviewee}
                onMarkCompleted={uiState.onMarkCompleted}
                onMarkUncompleted={uiState.onMarkUncompleted}
                uiState={uiState}
              />
          }
          {uiState.checkInState.isLoading && <Spinner />}
        </div>
      </div>}
      {_.isEmpty(uiState.checkInState.allCheckins) && <RevieweeDetailsEmptyState reviewee={uiState.checkInState.selectedReviewee}/>}
    </div>
  );
});

export default withState(RevieweeDetailsContainer, ManagerCheckInState);
